import { reportHybridOperateLog } from "@/api/setting";
import { $rrj } from "@/utils/rrjutils";

function safeStringify(value) {
  if (value == null) {
    return "";
  }
  if (typeof value === "string") {
    return value;
  }
  try {
    return JSON.stringify(value);
  } catch (error) {
    return String(value);
  }
}

function getCurrentOperatorContext() {
  const ukit = $rrj.storage.get("_ukit") || {};
  const childId = $rrj.storage.get("_child_id");
  const loginId = ukit.id || ukit.userId || null;
  const operatorUserId = childId || loginId;

  return {
    operator_login_id: loginId,
    operator_user_id: operatorUserId,
    operator_type: childId ? 2 : 1,
  };
}

export async function safeReportHybridOperateLog(payload) {
  try {
    const operatorContext = getCurrentOperatorContext();
    await reportHybridOperateLog({
      ...operatorContext,
      ...payload,
      before_json: safeStringify(payload.before_json),
      after_json: safeStringify(payload.after_json),
      extra_json: safeStringify(payload.extra_json),
    });
  } catch (error) {
    console.error("操作日志上报失败", error);
  }
}
